import '../../../../../assets/lib/skype/skype-external.js';

import { IAgentStatusDeprecatedService } from '@agent/core/agent/agent-status-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { ChannelDeprecatedImpl } from '@commons/models/channel';
import { IContact } from '@commons/models/contact';
import { IDeferred, ILogService, IPromise, IQService } from 'angular';
import { filter } from 'rxjs';

import {
  ActivityFacade,
  ActivityStatus,
  ActivityType,
  AgentSkillFacade,
  AgentStatus,
  BookingStatus,
  ChanEnum,
  Configuration,
  ConfigurationSkypeModel,
} from '@contact/upgrade';

const MODULE_NAME = 'skype';

const SKYPE_STATES = {
  ONLINE: 'Online',
  BUSY: 'Busy',
  DO_NOT_DISTURB: 'DoNotDisturb',
  BE_RIGHT_BACK: 'BeRightBack',
  AWAY: 'Away',
  OFFLINE: 'Offline',
};

const contactToSkypeMatrix = {
  [AgentStatus.AVAILABLE]: {
    [AgentStatus.BURNT]: {
      [SKYPE_STATES.AWAY]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.BE_RIGHT_BACK]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.BUSY]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.DO_NOT_DISTURB]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.ONLINE]: SKYPE_STATES.OFFLINE,
    },
    [AgentStatus.NOT_WORKING]: {
      [SKYPE_STATES.BE_RIGHT_BACK]: SKYPE_STATES.AWAY,
      [SKYPE_STATES.BUSY]: SKYPE_STATES.AWAY,
      [SKYPE_STATES.DO_NOT_DISTURB]: SKYPE_STATES.AWAY,
      [SKYPE_STATES.OFFLINE]: SKYPE_STATES.AWAY,
      [SKYPE_STATES.ONLINE]: SKYPE_STATES.AWAY,
    },
    [AgentStatus.WORKING]: {
      [SKYPE_STATES.AWAY]: SKYPE_STATES.BUSY,
      [SKYPE_STATES.BE_RIGHT_BACK]: SKYPE_STATES.BUSY,
      [SKYPE_STATES.DO_NOT_DISTURB]: SKYPE_STATES.BUSY,
      [SKYPE_STATES.OFFLINE]: SKYPE_STATES.BUSY,
      [SKYPE_STATES.ONLINE]: SKYPE_STATES.BUSY,
    },
  },
  [AgentStatus.BURNT]: {
    [AgentStatus.AVAILABLE]: {
      [SKYPE_STATES.AWAY]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.BE_RIGHT_BACK]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.BUSY]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.DO_NOT_DISTURB]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.OFFLINE]: SKYPE_STATES.ONLINE,
    },
  },
  [AgentStatus.CONNECTED]: {
    [AgentStatus.AVAILABLE]: {
      [SKYPE_STATES.AWAY]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.BE_RIGHT_BACK]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.BUSY]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.DO_NOT_DISTURB]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.OFFLINE]: SKYPE_STATES.ONLINE,
    },
    [AgentStatus.BURNT]: {
      [SKYPE_STATES.AWAY]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.BE_RIGHT_BACK]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.BUSY]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.DO_NOT_DISTURB]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.ONLINE]: SKYPE_STATES.OFFLINE,
    },
    [AgentStatus.NOT_WORKING]: {
      [SKYPE_STATES.AWAY]: SKYPE_STATES.BUSY,
      [SKYPE_STATES.BE_RIGHT_BACK]: SKYPE_STATES.BUSY,
      [SKYPE_STATES.BUSY]: SKYPE_STATES.BUSY,
      [SKYPE_STATES.DO_NOT_DISTURB]: SKYPE_STATES.BUSY,
      [SKYPE_STATES.OFFLINE]: SKYPE_STATES.BUSY,
      [SKYPE_STATES.ONLINE]: SKYPE_STATES.BUSY,
    },
    [AgentStatus.WORKING]: {
      [SKYPE_STATES.AWAY]: SKYPE_STATES.BUSY,
      [SKYPE_STATES.BE_RIGHT_BACK]: SKYPE_STATES.BUSY,
      [SKYPE_STATES.BUSY]: SKYPE_STATES.BUSY,
      [SKYPE_STATES.DO_NOT_DISTURB]: SKYPE_STATES.BUSY,
      [SKYPE_STATES.OFFLINE]: SKYPE_STATES.BUSY,
      [SKYPE_STATES.ONLINE]: SKYPE_STATES.BUSY,
    },
  },
  [AgentStatus.NOT_CONNECTED]: {
    [AgentStatus.AVAILABLE]: {
      [SKYPE_STATES.AWAY]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.BE_RIGHT_BACK]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.BUSY]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.DO_NOT_DISTURB]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.OFFLINE]: SKYPE_STATES.ONLINE,
    },
    [AgentStatus.CONNECTED]: {
      [SKYPE_STATES.AWAY]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.BE_RIGHT_BACK]: SKYPE_STATES.BE_RIGHT_BACK,
      [SKYPE_STATES.BUSY]: SKYPE_STATES.BUSY,
      [SKYPE_STATES.DO_NOT_DISTURB]: SKYPE_STATES.DO_NOT_DISTURB,
      [SKYPE_STATES.OFFLINE]: SKYPE_STATES.ONLINE,
    },
  },
  [AgentStatus.NOT_WORKING]: {
    [AgentStatus.AVAILABLE]: {
      [SKYPE_STATES.AWAY]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.BE_RIGHT_BACK]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.BUSY]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.DO_NOT_DISTURB]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.OFFLINE]: SKYPE_STATES.ONLINE,
    },
    [AgentStatus.BURNT]: {
      [SKYPE_STATES.AWAY]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.BE_RIGHT_BACK]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.BUSY]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.DO_NOT_DISTURB]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.OFFLINE]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.ONLINE]: SKYPE_STATES.OFFLINE,
    },
  },
  [AgentStatus.WORKING]: {
    [AgentStatus.AVAILABLE]: {
      [SKYPE_STATES.AWAY]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.BE_RIGHT_BACK]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.BUSY]: SKYPE_STATES.ONLINE,
      [SKYPE_STATES.OFFLINE]: SKYPE_STATES.ONLINE,
    },
    [AgentStatus.BURNT]: {
      [SKYPE_STATES.AWAY]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.BE_RIGHT_BACK]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.BUSY]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.DO_NOT_DISTURB]: SKYPE_STATES.OFFLINE,
      [SKYPE_STATES.ONLINE]: SKYPE_STATES.OFFLINE,
    },
  },
};

const skypeToContactMatrix = {
  [SKYPE_STATES.AWAY]: {
    [SKYPE_STATES.BUSY]: {
      [AgentStatus.AVAILABLE]: AgentStatus.NOT_WORKING,
      [AgentStatus.BURNT]: AgentStatus.NOT_WORKING,
      [AgentStatus.CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.NOT_WORKING,
    },
    [SKYPE_STATES.DO_NOT_DISTURB]: {
      [AgentStatus.AVAILABLE]: AgentStatus.NOT_WORKING,
      [AgentStatus.BURNT]: AgentStatus.NOT_WORKING,
      [AgentStatus.CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.WORKING,
    },
    [SKYPE_STATES.ONLINE]: {
      [AgentStatus.BURNT]: AgentStatus.AVAILABLE,
      [AgentStatus.CONNECTED]: AgentStatus.AVAILABLE,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.AVAILABLE,
      [AgentStatus.NOT_WORKING]: AgentStatus.AVAILABLE,
      [AgentStatus.WORKING]: AgentStatus.AVAILABLE,
    },
  },
  [SKYPE_STATES.BE_RIGHT_BACK]: {
    [SKYPE_STATES.BUSY]: {
      [AgentStatus.AVAILABLE]: AgentStatus.NOT_WORKING,
      [AgentStatus.CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.NOT_WORKING]: AgentStatus.NOT_WORKING,
    },
    [SKYPE_STATES.DO_NOT_DISTURB]: {
      [AgentStatus.AVAILABLE]: AgentStatus.NOT_WORKING,
      [AgentStatus.CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.NOT_WORKING]: AgentStatus.NOT_WORKING,
    },
    [SKYPE_STATES.ONLINE]: {
      [AgentStatus.CONNECTED]: AgentStatus.AVAILABLE,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.AVAILABLE,
      [AgentStatus.NOT_WORKING]: AgentStatus.AVAILABLE,
      [AgentStatus.WORKING]: AgentStatus.AVAILABLE,
    },
  },
  [SKYPE_STATES.BUSY]: {
    [SKYPE_STATES.AWAY]: {
      [AgentStatus.AVAILABLE]: AgentStatus.NOT_WORKING,
      [AgentStatus.BURNT]: AgentStatus.NOT_WORKING,
      [AgentStatus.CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.WORKING]: AgentStatus.NOT_WORKING,
    },
    [SKYPE_STATES.BE_RIGHT_BACK]: {
      [AgentStatus.AVAILABLE]: AgentStatus.NOT_WORKING,
      [AgentStatus.BURNT]: AgentStatus.NOT_WORKING,
      [AgentStatus.CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.WORKING]: AgentStatus.NOT_WORKING,
    },
    [SKYPE_STATES.ONLINE]: {
      [AgentStatus.BURNT]: AgentStatus.AVAILABLE,
      [AgentStatus.CONNECTED]: AgentStatus.AVAILABLE,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.AVAILABLE,
      [AgentStatus.NOT_WORKING]: AgentStatus.AVAILABLE,
      [AgentStatus.WORKING]: AgentStatus.AVAILABLE,
    },
  },
  [SKYPE_STATES.DO_NOT_DISTURB]: {
    [SKYPE_STATES.AWAY]: {
      [AgentStatus.AVAILABLE]: AgentStatus.NOT_WORKING,
      [AgentStatus.BURNT]: AgentStatus.NOT_WORKING,
      [AgentStatus.CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.WORKING]: AgentStatus.NOT_WORKING,
    },
    [SKYPE_STATES.BE_RIGHT_BACK]: {
      [AgentStatus.AVAILABLE]: AgentStatus.NOT_WORKING,
      [AgentStatus.BURNT]: AgentStatus.NOT_WORKING,
      [AgentStatus.CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.WORKING]: AgentStatus.NOT_WORKING,
    },
    [SKYPE_STATES.ONLINE]: {
      [AgentStatus.BURNT]: AgentStatus.AVAILABLE,
      [AgentStatus.CONNECTED]: AgentStatus.AVAILABLE,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.AVAILABLE,
      [AgentStatus.WORKING]: AgentStatus.AVAILABLE,
    },
  },
  [SKYPE_STATES.OFFLINE]: {
    [SKYPE_STATES.BUSY]: {
      [AgentStatus.AVAILABLE]: AgentStatus.WORKING,
      [AgentStatus.BURNT]: AgentStatus.WORKING,
      [AgentStatus.CONNECTED]: AgentStatus.WORKING,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.WORKING,
      [AgentStatus.NOT_WORKING]: AgentStatus.WORKING,
    },
    [SKYPE_STATES.ONLINE]: {
      [AgentStatus.BURNT]: AgentStatus.AVAILABLE,
      [AgentStatus.CONNECTED]: AgentStatus.AVAILABLE,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.AVAILABLE,
      [AgentStatus.NOT_WORKING]: AgentStatus.AVAILABLE,
      [AgentStatus.WORKING]: AgentStatus.AVAILABLE,
    },
  },
  [SKYPE_STATES.ONLINE]: {
    [SKYPE_STATES.AWAY]: {
      [AgentStatus.AVAILABLE]: AgentStatus.NOT_WORKING,
      [AgentStatus.BURNT]: AgentStatus.NOT_WORKING,
      [AgentStatus.CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.WORKING]: AgentStatus.NOT_WORKING,
    },
    [SKYPE_STATES.BE_RIGHT_BACK]: {
      [AgentStatus.AVAILABLE]: AgentStatus.NOT_WORKING,
      [AgentStatus.BURNT]: AgentStatus.NOT_WORKING,
      [AgentStatus.CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.WORKING]: AgentStatus.NOT_WORKING,
    },
    [SKYPE_STATES.BUSY]: {
      [AgentStatus.AVAILABLE]: AgentStatus.NOT_WORKING,
      [AgentStatus.BURNT]: AgentStatus.NOT_WORKING,
      [AgentStatus.CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.WORKING]: AgentStatus.NOT_WORKING,
    },
    [SKYPE_STATES.DO_NOT_DISTURB]: {
      [AgentStatus.AVAILABLE]: AgentStatus.NOT_WORKING,
      [AgentStatus.BURNT]: AgentStatus.NOT_WORKING,
      [AgentStatus.CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.NOT_CONNECTED]: AgentStatus.NOT_WORKING,
      [AgentStatus.WORKING]: AgentStatus.NOT_WORKING,
    },
  },
};

/**
 * SkypeToContactMatrix defines how the Booking agent status should change when the skype status changes.
 * It depends on the current skype status, the new skype status and the current agent status,
 * It's of the form:
 *
 * "skypeToContactMatrix":{
 *   "current-skype-status1":{
 *     "new-skype-status1":{
 *       "CURRENT-AGENT-STATUS1":"NEW-AGENT-STATUS1",
 *       "CURRENT-AGENT-STATUS2":"NEW-AGENT-STATUS2",
 *       "CURRENT-AGENT-STATUS3":"NEW-AGENT-STATUS3",
 *       "CURRENT-AGENT-STATUS4":"NEW-AGENT-STATUS4"
 *     },
 *     "new-skype-status1":{
 *       "CURRENT-AGENT-STATUS1":"NEW-AGENT-STATUS1",
 *       "CURRENT-AGENT-STATUS2":"NEW-AGENT-STATUS2"
 *     },
 *     <...>
 *   },
 *   "current-skype-status1":{
 *   <...>
 * }
 *
 * contactToSkypeMatrix defines how the Skype status should change when the Booking agent status changes.
 * It depends on the current agent status, the new agent status and the current Skype status
 *
 * "skypeToContactMatrix":{
 *   "CURRENT-AGENT-STATUS1":{
 *     "NEW-AGENT-STATUS1":{
 *       "current-skype-status1":"new-skype-status1",
 *       "current-skype-status2":"new-skype-status2",
 *       "current-skype-status3":"new-skype-status3",
 *       "current-skype-status4":"new-skype-status4"
 *     },
 *     "NEW-AGENT-STATUS2":{
 *       "current-skype-status1":"new-skype-status1",
 *       "current-skype-status4":"new-skype-status4"
 *     },
 *     <...>
 *   },
 *   "CURRENT-AGENT-STATUS1":{
 *   <...>
 * }
 *
 * Only write a line in either of the matrices if it is useful to you, if a case is not present is a matrix, no state change will occur
 *
 * the skype status are the string from the SKYPE_STATES map hereafter:
 * "Online", "Busy", "DoNotDisturb", "BeRightBack", "Away", "Offline"
 *
 * the agent status are the one from the AgentStatus enum in agent-state.js (in ALL_CAPS)
 *
 */

export interface ISkypeService {
  logon(): IPromise<any>;
  logout(): IPromise<any>;
}

export class SkypeService implements ISkypeService {
  static $inject: Array<string> = [
    '$q',
    '$log',
    'agentStatusDeprecatedService',
    'activityFacade',
    'configuration',
    'contactDeprecatedService',
    'agentSkillFacade',
  ];

  public name = MODULE_NAME;

  private config: ConfigurationSkypeModel;

  private remainingReconnections: number = 5;

  private Skype: any = (window as any).Skype;
  private skypeWebApp: any;
  private mePerson: any;
  private skypePresenceSubscription: any;
  private currentSkypeStatus: string;
  private currentAgentState: string;
  private activityInProgress: boolean = false;

  constructor(
    private readonly $q: IQService,
    private readonly $log: ILogService,
    private readonly agentStatusDeprecatedService: IAgentStatusDeprecatedService,
    private readonly activityFacade: ActivityFacade,
    private readonly configuration: Configuration,
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly agentSkillFacade: AgentSkillFacade
  ) {
    this.config = this.configuration.skype ?? {
      domain: '',
      keys: {},
    };

    /**
     * listen to pause state success
     */
    this.activityFacade.success$
      .pipe(
        // if type is Lync/Skype && status is CANCELED
        filter(({ activity, current }) => activity.type === ActivityType.LYNC && current === ActivityStatus.CANCELED)
      )
      .subscribe(({ id }) => {
        this.activityFacade.updateTransition(id, ActivityStatus.FINISHED);
        this.$log.debug('[Skype] pause finished');
      });

    // Skype is in progress
    this.activityFacade.isTypeInprogress(ActivityType.LYNC).subscribe(inProgress => (this.activityInProgress = inProgress));
  }

  // logon to Skype
  public logon(deferred: IDeferred<any> = this.$q.defer()): IPromise<any> {
    this.Skype.initialize(
      this.config.keys,
      api => {
        this.skypeWebApp = new api.application();
        this.skypeWebApp.signInManager
          .signIn({
            domain: this.config.domain,
          })
          .then(
            () => {
              this.remainingReconnections = 5;
              this.handleSkypeSignin();
              deferred.resolve();
            },
            err => {
              this.$log.debug('[Skype] cannot sign in to Skype');

              if (--this.remainingReconnections > 0) {
                // on error we try to reconnect at most "remainingReconnections" times
                setTimeout(() => this.logon(deferred), 5000);
              } else {
                this.$log.debug('[Skype] cannot sign in to Skype after the max number of retries', err);
                deferred.reject();
              }
            }
          );
      },
      err => {
        this.$log.debug('[Skype] Cannot load the SDK.');
        this.$log.debug(err);
      }
    );

    // we listen to Booking events for the current agent
    this.agentStatusDeprecatedService.success().subscribe(event => {
      this.handleStatusChangeFromContact(event.newState);
    });

    return deferred.promise;
  }

  private handleSkypeSignin() {
    this.mePerson = this.skypeWebApp.personsAndGroupsManager.mePerson;
    this.$log.log('[Skype] signed in as', this.mePerson.displayName());

    // we get the initial status value
    this.mePerson.status.get().then(
      status => this.handleStatusChangeFromSkype(status),
      err => this.$log.log("[Skype] couldn't get the initial status", err)
    );

    // we listen to skype events for the current connected user
    this.mePerson.status.changed(
      status => this.handleStatusChangeFromSkype(status),
      err => this.$log.debug('[Skype] error while changing skype status', err)
    );
    this.skypePresenceSubscription = this.mePerson.status.subscribe();
  }

  /**
   * sets the new Agent status based on the current Agent status, the current Skype status and the next Skype status
   * @param newSkypeStatus the new Skype status
   */
  private handleStatusChangeFromSkype(newSkypeStatus: string) {
    const currentAgentState = AgentStatus[this.agentStatusDeprecatedService.getCurrentAgentState().toString()];
    const newState: string =
      skypeToContactMatrix[this.currentSkypeStatus] &&
      skypeToContactMatrix[this.currentSkypeStatus][newSkypeStatus] &&
      skypeToContactMatrix[this.currentSkypeStatus][newSkypeStatus][currentAgentState];
    if (newState !== undefined) {
      this.updateAgentState(newState);
    } else {
      this.$log.debug(
        "[Skype] no target Agent state when changing skype status from '" +
          this.currentSkypeStatus +
          "' to '" +
          newSkypeStatus +
          "', with current Agent state '" +
          currentAgentState +
          "'"
      );
    }
    this.currentSkypeStatus = newSkypeStatus;
  }

  /**
   * sets the new Skype status based on the current Skype status, the current Agent status and the next Agent status
   * @param newAgentStateStr the new Agent status (in string form)
   */
  private handleStatusChangeFromContact(newAgentStateStr: string) {
    if (this.mePerson) {
      const newSkypeStatus =
        contactToSkypeMatrix[this.currentAgentState] &&
        contactToSkypeMatrix[this.currentAgentState][newAgentStateStr] &&
        contactToSkypeMatrix[this.currentAgentState][newAgentStateStr][this.currentSkypeStatus];
      // in the case of NOT_CONNECTED we also disconnect from Skype
      if (AgentStatus[newAgentStateStr] === AgentStatus.NOT_CONNECTED) this.logout();
      if (newSkypeStatus) {
        this.mePerson.status.set(newSkypeStatus);
        this.currentSkypeStatus = newSkypeStatus;
      } else {
        this.$log.debug(
          "[Skype] no target Skype state when changing Agent status from '" +
            this.currentAgentState +
            "' to '" +
            newAgentStateStr +
            "', with current Skype state '" +
            this.currentSkypeStatus +
            "'"
        );
      }
    }
    this.currentAgentState = newAgentStateStr;
  }

  /**
   * sets the availability of the agents skill depending on a given agent state
   * starts/end a lync pause in some cases too
   * @param newAgentStateStr the new Agent status (in string form)
   */
  private updateAgentState(newAgentStateStr: string): void {
    let newAgentState: AgentStatus = AgentStatus[newAgentStateStr];
    // if the AgentStatus is not null it means the new state is a "classic" agent state
    if (newAgentState != null) {
      // other states correspond to AgentStatus
      const contacts: IContact[] = this.contactDeprecatedService.getContactsByChannel(ChannelDeprecatedImpl.INCOMING_PHONE);

      switch (newAgentState) {
        case AgentStatus.CONNECTED:
        case AgentStatus.AVAILABLE:
          let inPostProcessing = false;
          if (contacts && contacts[0]) {
            inPostProcessing = this.contactDeprecatedService.getContactState(contacts[0].responseId) === BookingStatus.POST_PROCESSING;
          }
          if (!inPostProcessing && this.activityInProgress) {
            // we end the pause only if there's no current post processing
            this.endActivity();
          }
          this.updateStateVoiceSkills(true);
          break;
        case AgentStatus.NOT_WORKING:
          if (!(contacts && contacts[0]) && this.currentSkypeStatus === SKYPE_STATES.ONLINE && !this.activityInProgress) {
            // starts a pause if they agent is available
            this.startActivity();
          }
        case AgentStatus.WORKING:
        case AgentStatus.NOT_CONNECTED:
        case AgentStatus.BURNT:
          this.updateStateVoiceSkills(false);
          break;
        default:
          break;
      }
    } else {
      this.$log.debug("[Skype] '" + newAgentStateStr + "' is not an valid Agent Status");
    }
  }

  /**
   * closes or opens all of the vocal skills of the current agent
   */
  private updateStateVoiceSkills(isAvailable: boolean) {
    this.agentSkillFacade.changeAllActivation(ChanEnum.In.Phone, isAvailable);
    this.agentSkillFacade.changeAllActivation(ChanEnum.Out.Phone, isAvailable);
  }

  /**
   * logout from Skype
   */
  public logout(): IPromise<any> {
    let deferred = this.$q.defer();
    if (this.mePerson) {
      this.skypePresenceSubscription.dispose();
      this.skypeWebApp.signInManager.signOut();
    }
    deferred.resolve(); // the returned promise is already resolved
    return deferred.promise;
  }

  /**
   * starts a Lync-typed activity
   */
  private startActivity() {
    this.activityFacade.openForm(ActivityType.LYNC);
  }

  /**
   * ends the activty if it exists
   */
  private endActivity() {
    this.activityFacade.updateTransitionByType(ActivityType.LYNC, ActivityStatus.FINISHING);
  }
}

export default MODULE_NAME;
